import React from "react";
import classNames from "classnames";
import { EventIcon } from "@common/eventIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Event({
  height,
  width,
  isHovered,
  onClick,
  onMouseDown,
  onMouseMove,
  onTouchStart,
  onTouchMove,
}: Props) {
  return (
    <div
      className={classNames(styles.event, {
        [styles.hovered]: isHovered,
      })}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
    >
      <svg className={styles.element} width={width} height={height}>
        <path
          d={`
            M0 10
            C0 0, 0 0, 10 0
            H${width - 10}
            C${width} 0, ${width} 0, ${width} 10
            V${height - 15}
            C${width} ${height - 5}, ${width} ${height - 5}, ${width - 10} ${
              height - 5
            }
            L${width - 10} ${height - 5}
            H${10}
            C0 ${height - 5}, 0 ${height - 5}, 0 ${height - 15}
            L0 ${height - 5}
            Z
        `}
        />
      </svg>
      <EventIcon
        className={styles.icon}
        style={{
          width: height - 10,
          height: height - 10,
          top: (height - 5) / 2,
        }}
      />
    </div>
  );
}

export { Event };
